import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import SpotifyService from "./services/spotify.service";
import components from "@/components";

(function (w, d, s, l, i) {
    w[l] = w[l] || []; w[l].push({
        'gtm.start':
            new Date().getTime(), event: 'gtm.js'
    }); var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
            'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
})(window, document, 'script', 'dataLayer', 'GTM-PNXP43J');

SpotifyService.createGenerator().then(() => {
    Vue.config.productionTip = false;

    Object.keys(components).forEach(key => {
        Vue.component(key, components[key]);
    });

    new Vue({
        router,
        render: h => h(App),  
    }).$mount("#container");
});
